import React, { FunctionComponent } from "react";

import { bemClassNames } from "@multiweb/reactUtils";

export type DropdownCaptionItemComponentProps = {
    /** Text, který se zobrazí v titulku */
    text: string;
};

const className = bemClassNames("dropdown-caption-item-component");

export const DropdownCaptionItemComponent: FunctionComponent<DropdownCaptionItemComponentProps> = ({
    text,
}) => (
    <label className={className()}>{text}</label>
);
